export const config = {
  WEBSITE_URL: "https://api.izzi.software",
  FORM_ID: "612", //Form id that provides Contact Form 7
  USER_NAME: "subscriber",
  USER_PASSWORD: "o1Im^LPIJUQPzneFDGecFLZ6",
  CAPTCHA_KEY: "6LeAOWMaAAAAAEESH8sbCpvijiB4W4rVrx8ZSooc",
}
